// Storage Keys
export const STORAGE_KEYS = {
  CAMPUSES: "als_campuses",
  SESSIONS: "als_sessions",
  CLASSES: "als_classes",
  STUDENTS: "als_students",
};

// Get data from localStorage
export const getData = (key) => {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error(`Error getting data from ${key}:`, error);
    return [];
  }
};

// Save data to localStorage
export const saveData = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error(`Error saving data to ${key}:`, error);
  }
};

// Generate unique ID
export const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};
